'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MyPlacesModal = require('./myplaces_modal');

var _require = require('../../../src/frontend/helper/search/common/m_keypress.coffee'),
    whichKeyAlias = _require.whichKeyAlias;

var DesktopMyPlacesModal = function (_MyPlacesModal) {
  _inherits(DesktopMyPlacesModal, _MyPlacesModal);

  function DesktopMyPlacesModal() {
    _classCallCheck(this, DesktopMyPlacesModal);

    var _this = _possibleConstructorReturn(this, (DesktopMyPlacesModal.__proto__ || Object.getPrototypeOf(DesktopMyPlacesModal)).call(this));

    _this.bindEvents();
    return _this;
  }

  _createClass(DesktopMyPlacesModal, [{
    key: 'bindEvents',
    value: function bindEvents() {
      _get(DesktopMyPlacesModal.prototype.__proto__ || Object.getPrototypeOf(DesktopMyPlacesModal.prototype), 'bindEvents', this).call(this);
      this.$location.on('keydown', this.handleInputKeydown.bind(this));
      this.$resultList.on('keydown', 'a', this.handleListKeydown.bind(this));
    }

    // open the add-address modal

  }, {
    key: 'open',
    value: function open() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var locationsAutocomplete = arguments[1];

      if (GIG && GIG.Modal) {
        GIG.Modal.open({ id: 'my-places-modal' });
      }
      _get(DesktopMyPlacesModal.prototype.__proto__ || Object.getPrototypeOf(DesktopMyPlacesModal.prototype), 'open', this).call(this, address);

      if (locationsAutocomplete) {
        locationsAutocomplete.hide(); // hide location typeahead
      }
    }

    // keydown on the autocomplete list
    // use keyboard to select the items

  }, {
    key: 'handleListKeydown',
    value: function handleListKeydown(e) {
      var $results = this.$resultList.find('a');

      switch (whichKeyAlias(e)) {
        case 'ArrowUp':
        case 'Up':
          $results.eq($results.index(e.currentTarget) - 1).focus();
          break;
        case 'ArrowDown':
        case 'Down':
          $results.eq($results.index(e.currentTarget) + 1).focus();
          break;
        case 'Enter':
        case 'Tab':
          this.selectPlace(e.currentTarget);
          break;
        default:
      }
    }
  }, {
    key: 'handleInputKeydown',
    value: function handleInputKeydown(e) {
      switch (whichKeyAlias(e)) {
        case 'ArrowDown':
        case 'Down':
          this.$resultList.find('a').eq(0).focus();
          this.$resultList.find('.typeahead-match').removeClass('typeahead-match-highlight');
          e.preventDefault();
          break;
        default:
      }
    }
  }]);

  return DesktopMyPlacesModal;
}(MyPlacesModal);

module.exports = DesktopMyPlacesModal;